import React, { useEffect, useRef, useState } from "react";

const BUTTON_DELAY_MS = 5000;

const CreatePassword: React.FC = () => {
  const [buttonEnabled, setButtonEnabled] = useState(false);
  const [showWebFallback, setShowWebFallback] = useState(false);
  const buttonTimerRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  const urlParams = new URLSearchParams(window.location.search);
  const email = urlParams.get("email") || "";
  const resetToken = urlParams.get("resetToken") || "";
  const userType = urlParams.get("userType") || "";

  const deepLink =
    `ccf://create-password` +
    `?email=${encodeURIComponent(email)}` +
    `&resetToken=${encodeURIComponent(resetToken)}` +
    `&userType=${encodeURIComponent(userType)}`;

  const webResetHref =
    `/new-password?token=${encodeURIComponent(resetToken)}&user_type=${encodeURIComponent(userType)}`;

  const triggerDeepLink = () => {
    window.location.href = deepLink;
  };

  useEffect(() => {
    // Attempt deep link immediately on load
    triggerDeepLink();

    const handleVisibilityChange = () => {
      // App opened — cancel the button timer
      if (document.hidden && buttonTimerRef.current) {
        clearTimeout(buttonTimerRef.current);
      }
    };
    document.addEventListener("visibilitychange", handleVisibilityChange);

    // Enable "Open App" button after 5 s if still on this page
    buttonTimerRef.current = setTimeout(() => {
      setButtonEnabled(true);
    }, BUTTON_DELAY_MS);

    return () => {
      if (buttonTimerRef.current) clearTimeout(buttonTimerRef.current);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, []);

  const handleOpenApp = () => {
    triggerDeepLink();
    setShowWebFallback(true);
  };

  return (
    <div className="flex justify-center items-center min-h-screen overflow-y-auto p-5">
      <div>
        <img className="mb-9" src="./images/web-logo.png" alt="web-logo" />

        <div className="bg-sky border border-sky py-5 md:py-9 px-5 md:px-16 rounded-[20px] max-w-[448px] text-center">
          <h3 className="text-secondary text-2xl font-semibold mb-4">
            Reset Your Password
          </h3>

          <p className="text-base font-light text-secondaryVariant mb-6">
            {buttonEnabled
              ? "Tap the button below to open the Childcare Forward app."
              : "Redirecting you to the Childcare Forward app…"}
          </p>

          <button
            onClick={handleOpenApp}
            disabled={!buttonEnabled}
            className={`btnPrimary w-full mb-4 ${!buttonEnabled ? "opacity-50 cursor-not-allowed" : ""}`}
          >
            Open App
          </button>

          {showWebFallback && (
            <p className="text-sm font-light text-secondaryVariant mt-2">
              Don&apos;t have the app?{" "}
              <a href={webResetHref} className="text-secondary font-medium underline">
                Reset your password here.
              </a>
            </p>
          )}
        </div>
      </div>
    </div>
  );
};

export default CreatePassword;
